import service from '@/utils/request'

/**
 * banner轮播
 */
export function getBannerList() {
    return service({
        url: '/api/banner/getList',
        method: 'get'
    })
}

